<style>
  .mat-column-acciones {
    text-align: right;
  }
  .mat-column-archivo {
    text-align: center;
  }
</style>

<div class="main-container">
  <p class="tituloNombre">Paciente: {{ paciente?.name }} {{ paciente?.surname }}</p>
  <!-- Aviso datos faltantes del paciente -->
  <div *ngIf="paciente && !paciente.datos_receta_completos && recetarioStatus?.habilitado" class="datos-faltantes-container">
    <mat-accordion>
      <mat-expansion-panel
        class="mat-elevation-z4"
        [expanded]="editandoDatosPaciente"
        (opened)="mostrarFormDatosPaciente()"
        hideToggle
      >
        <mat-expansion-panel-header class="datos-faltantes-panel-header" (click)="editandoDatosPaciente = !editandoDatosPaciente">
          <div class="datos-faltantes-title">
            <span>Completar datos del paciente</span>
            <mat-icon *ngIf="!editandoDatosPaciente">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="editandoDatosPaciente">keyboard_arrow_up</mat-icon>
          </div>
        </mat-expansion-panel-header>
        <div class="datos-faltantes-body">
          <p class="datos-faltantes-descripcion">Completá los datos faltantes para emitir recetas y órdenes.</p>
          <div class="datos-faltantes-row">
            <mat-form-field *ngIf="campoFaltante('name')" appearance="fill" class="input">
              <mat-label>Nombre</mat-label>
              <input matInput [(ngModel)]="editName" />
            </mat-form-field>
            <mat-form-field *ngIf="campoFaltante('surname')" appearance="fill" class="input">
              <mat-label>Apellido</mat-label>
              <input matInput [(ngModel)]="editSurname" />
            </mat-form-field>
          </div>
          <div class="datos-faltantes-row">
            <mat-form-field *ngIf="campoFaltante('numeroDocumento')" appearance="fill" class="input">
              <mat-label>Nro. Documento</mat-label>
              <input matInput [(ngModel)]="editDocumento" />
            </mat-form-field>
            <mat-form-field *ngIf="campoFaltante('gender')" appearance="fill" class="input">
              <mat-label>Género</mat-label>
              <mat-select [(ngModel)]="editGender">
                <mat-option value="m">Masculino</mat-option>
                <mat-option value="f">Femenino</mat-option>
                <mat-option value="o">Otro</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="datos-faltantes-row">
            <mat-form-field *ngIf="campoFaltante('fechaNacimiento')" appearance="fill" class="input">
              <mat-label>Fecha de nacimiento</mat-label>
              <input matInput type="date" [(ngModel)]="editFechaNacimiento" />
            </mat-form-field>
            <mat-form-field *ngIf="campoFaltante('obraSocial')" appearance="fill" class="input">
              <mat-label>Obra social</mat-label>
              <mat-select [(ngModel)]="editObraSocial">
                <mat-option>
                  <ngx-mat-select-search
                    [noEntriesFoundLabel]="'No encontrado'"
                    [placeholderLabel]="'Buscar obra social'"
                    [formControl]="obraSocialBuscador"
                    (ngModelChange)="filtrarObraSocial()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="0">Particular (sin cobertura)</mat-option>
                <mat-option *ngFor="let obra of filtroObrasSociales" [value]="obra.id">{{ obra.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="datos-faltantes-acciones">
            <button
              mat-raised-button
              class="buttonForm"
              (click)="guardarDatosPaciente()"
              [disabled]="guardandoDatos"
            >
              {{ guardandoDatos ? "Guardando..." : "Guardar" }}
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="form-buttons" *ngIf="formData?.crearEstudiosMedicos === 1">
    <button
      mat-raised-button
      color="primary"
      class="btn-crear-estudio"
      (click)="openFormDialog('estudio')"
    >
      <mat-icon>note_add</mat-icon>
      Crear estudio
    </button>
    <button
      mat-raised-button
      class="btn-crear-receta"
      (click)="openFormDialog('receta')"
      [disabled]="recetaDeshabilitada"
      [matTooltip]="recetaTooltip"
    >
      <mat-icon>receipt</mat-icon>
      Crear receta
    </button>
    <button
      mat-raised-button
      class="btn-crear-orden"
      (click)="openFormDialog('orden')"
      [disabled]="ordenDeshabilitada"
      [matTooltip]="ordenTooltip"
    >
      <mat-icon>assignment</mat-icon>
      Crear orden
    </button>
  </div>
  <ng-container *ngIf="tipoestudios == 1; else elseblock">
    <div class="table-paginator-wrapper container">
    <table
      class="mat-elevation-z4 mat-table"
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="fecha">
        <mat-header-cell *matHeaderCellDef>
          <span *ngIf="historialMedico == false" class="tabCell"
            >FECHA ESTUDIO</span
          >
          <span *ngIf="historialMedico == true" class="tabCell"
            >HISTORIAL MEDICO</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="FECHA ESTUDIO">
          <span class="valCell">{{ element.fecha }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="estudio">
        <mat-header-cell *matHeaderCellDef>
          <span *ngIf="historialMedico == false" class="tabCell">ESTUDIO</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="ESTUDIO">
          <span class="valCell">{{ element.nombreEM }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <mat-header-cell *matHeaderCellDef>
          <span class="tabCell">TIPO</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="TIPO">
          <span class="valCell">{{ element.tipo === 'receta' ? 'Receta' : element.tipo === 'orden' ? 'Orden' : element.tipo === 'odontograma' ? 'Odontograma' : 'Estudio' }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="estado">
        <mat-header-cell *matHeaderCellDef>
          <span class="tabCell">ESTADO</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="ESTADO">
          <span *ngIf="element.tipo !== 'receta' && element.tipo !== 'orden'" class="valCell">-</span>
          <span *ngIf="element.tipo === 'receta' && element.status === 'active'" class="valCell" style="color: #4caf50; font-weight: 500;">Activa</span>
          <span *ngIf="element.tipo === 'receta' && element.status === 'cancelled'" class="valCell receta-anulada">Anulada</span>
          <span *ngIf="element.tipo === 'orden' && element.status === 'active'" class="valCell" style="color: #4caf50; font-weight: 500;">Activa</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="medico">
        <mat-header-cell *matHeaderCellDef>
          <span *ngIf="historialMedico == false" class="tabCell">MÉDICO</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="MEDICO">
          <div class="divFoto">
            <img
              class="tablaImg"
              style="display: none"
              (load)="cargarImagen($event)"
              src="{{ url }}storage/images/medico/{{ element.imagenM }}"
            />
            <span class="valCell">{{ element.nombreM }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="centromedico">
        <mat-header-cell *matHeaderCellDef>
          <span *ngIf="historialMedico == false" class="tabCell"
            >CENTRO MÉDICO</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="CENTRO MEDICO">
          <div class="divFoto">
            <img
              class="tablaImg"
              style="display: none"
              (load)="cargarImagen($event)"
              src="{{ url }}storage/images/centro-medico/{{ element.imagenCM }}"
            />
            <span class="valCell">{{ element.nombreCM }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="acciones">
        <mat-header-cell *matHeaderCellDef>
          <span *ngIf="historialMedico == false" class="tabCell">ACCIONES</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" data-label="ACCIONES">
          <!-- Acciones para estudios médicos -->
          <div class="divIcons" *ngIf="element.tipo !== 'receta' && element.tipo !== 'orden'">
            <div class="divIcon ver">
              <mat-icon
                [routerLink]="[
                  '/seccion-medico',
                  paciente.id,
                  'estudios-medicos',
                  'detalle',
                  element.id
                ]"
                class="icon"
                >visibility</mat-icon
              >
            </div>
            <div
              *ngIf="element.tipo === 'imagenes'"
              class="ver divIcon"
              (click)="compartirImagenes(element)"
              matTooltip="Compartir por Email"
            >
              <mat-icon class="icon">share</mat-icon>
            </div>
            <div
              *ngIf="medico && medico?.id === element.idM"
              (click)="
                element.editable &&
                  editarEstudio([
                    'seccion-medico',
                    paciente.id,
                    'estudios-medicos',
                    'editar',
                    element.id
                  ])
              "
              class="editar divIcon"
              [style]="
                !element.editable ? 'background: red; cursor:not-allowed' : ''
              "
              [matTooltip]="
                !element.editable ? 'Ya no es posible la edición' : 'Editar'
              "
            >
              <mat-icon [state]="{ paciente: 'paciente' }" class="icon">
                edit</mat-icon
              >
            </div>
            <div (click)="descargarPDFEstudioMedico(element)" class="borrar divIcon">
              <mat-icon class="icon">cloud_download</mat-icon>
            </div>
          </div>
          <!-- Acciones para órdenes digitales -->
          <div class="divIcons" *ngIf="element.tipo === 'orden'">
            <div
              *ngIf="element.archivos?.length"
              class="divIcon ver"
              (click)="verPdfOrden(element)"
              matTooltip="Ver PDF orden"
            >
              <mat-icon class="icon">picture_as_pdf</mat-icon>
            </div>
            <div
              *ngIf="element.status === 'active' && puedeCompartir"
              class="divIcon ver"
              (click)="compartirOrden(element)"
              matTooltip="Compartir por WhatsApp/Email"
            >
              <mat-icon class="icon">share</mat-icon>
            </div>
          </div>
          <!-- Acciones para recetas digitales -->
          <div class="divIcons" *ngIf="element.tipo === 'receta'">
            <div
              *ngIf="element.archivos?.length"
              class="divIcon ver"
              (click)="verPdfReceta(element)"
              matTooltip="Ver PDF receta"
            >
              <mat-icon class="icon">picture_as_pdf</mat-icon>
            </div>
            <div
              *ngIf="element.status === 'active' && puedeCompartir"
              class="divIcon ver"
              (click)="compartirReceta(element)"
              matTooltip="Compartir por WhatsApp/Email"
            >
              <mat-icon class="icon">share</mat-icon>
            </div>
            <div
              *ngIf="element.status === 'active' && medico?.id === element.idM"
              class="divIcon borrar"
              (click)="anularReceta(element)"
              matTooltip="Anular receta"
            >
              <mat-icon class="icon">cancel</mat-icon>
            </div>
            <span
              *ngIf="element.status === 'cancelled'"
              class="receta-anulada"
            >
              Anulada
            </span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td
          class="row-expanded color"
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="cols.length"
        >
          <div
            class="example-element-detail"
            [@detailExpand]="
              element == expandedElement ? 'expanded' : 'collapsed'
            "
          >
            <!-- <div>
              <div class="grid grid-expansion">
                <div class="col-7">
                  <div class="divTitle">
                    <span class="colapTitle">OBSERVACIONES</span>
                  </div>
                  <div class="colapDesc">{{ element.observaciones }}</div>
                  <img
                    [routerLink]="[
                      '/seccion-medico/estudios-medicos/detalle',
                      element.id
                    ]"
                    matTooltip="Informe Completo"
                    aria-label="Button that displays a tooltip when focused or hovered over"
                    src="assets/img/ico_verMas.png"
                    class="verMas"
                  />
                </div>
              </div>
            </div> -->
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsFiles"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: columnsFiles"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="select(expandedElement, element)"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="example-detail-row"
      ></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[10, 20, 30]"
      showFirstLastButtons
      aria-label="Select page of periodic elements"
    >
    </mat-paginator>
    </div>
  </ng-container>
  <ng-template #elseblock>
    <table
      class="mat-elevation-z4"
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="fecha">
        <th class="column-date" mat-header-cell *matHeaderCellDef>
          Fecha estudio
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.fecha }}
        </td>
      </ng-container>

      <ng-container matColumnDef="archivo">
        <th mat-header-cell *matHeaderCellDef class="th">
          <span class="span">Nombre del documento</span>
        </th>
        <td mat-cell *matCellDef="let element" class="td">
          {{
            element.imagen
              ? element.imagen.descripcion
                ? element.imagen.descripcion
                : element.imagen.nombre
              : "No tiene"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef class="th">Acciones</th>
        <td mat-cell *matCellDef="let element" class="td">
          <mat-icon class="verImagen" (click)="mostrarImagen(element.imagen)"
            >visibility
          </mat-icon>

          <mat-icon
            *ngIf="
              element.imagen ? element.imagen.nombre.slice(-4) == 'xlsx' : ''
            "
            class="dExcel"
            (click)="descargarExcel(element)"
            >download1</mat-icon
          >
          <mat-icon
            *ngIf="
              element.imagen ? element.imagen.nombre.slice(-3) == 'pdf' : ''
            "
            class="dExcel"
            (click)="descargarPdf(element)"
            >download2</mat-icon
          >
          <mat-icon
            *ngIf="
              element.imagen
                ? element.imagen.nombre.slice(-4) != 'xlsx' &&
                  element.imagen.nombre.slice(-3) != 'pdf'
                : ''
            "
            class="dExcel"
            (click)="descargarImage(element)"
            >download3</mat-icon
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsFile"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsFile"></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[10, 20, 30]"
      showFirstLastButtons
      aria-label="Select page of periodic elements"
    >
    </mat-paginator>
  </ng-template>
</div>

<p-overlayPanel #op [showCloseIcon]="true">
  <ng-template pTemplate>
    <img src="assets/img/avatar.png" />
    John Doe
    <p>Nombre:</p>
    <p>Matrícula:</p>
    <p>Teléfono:</p>
  </ng-template>
</p-overlayPanel>
